(function () {
  var userOpenedCart = false;

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;

      if (target && target.nodeType !== 1) {
        target = target.parentElement;
      }

      if (!target || !target.closest) {
        return;
      }

      if (
        target.closest('.js-drawer-open-button-right') ||
        target.closest('.add-to-cart') ||
        target.closest('[name="add"]') ||
        target.closest('.quick-add-size-btn')
      ) {
        userOpenedCart = true;
      }
    },
    true
  );

  function cartOpenAllowed() {
    return userOpenedCart || window.__allowCartDrawer === true;
  }

  function closeAutoOpenedDrawer() {
    if (cartOpenAllowed()) {
      return;
    }

    document.body.classList.remove('js-drawer-open', 'js-drawer-open-right');

    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.classList.remove('js-drawer-open');
    }

    if (window.timber && window.timber.RightDrawer) {
      window.timber.RightDrawer.drawerIsOpen = false;
    }
  }

  function watchForAutoOpen() {
    if (userOpenedCart || !window.MutationObserver) {
      return;
    }

    var observer = new MutationObserver(function () {
      if (
        !cartOpenAllowed() &&
        document.body.classList.contains('js-drawer-open-right')
      ) {
        closeAutoOpenedDrawer();
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    closeAutoOpenedDrawer();
    watchForAutoOpen();
    setTimeout(closeAutoOpenedDrawer, 100);
    setTimeout(closeAutoOpenedDrawer, 500);
    setTimeout(closeAutoOpenedDrawer, 1500);
  });
})();
